import { render, staticRenderFns } from "./PR1.vue?vue&type=template&id=b2fde87a&"
import script from "./PR1.vue?vue&type=script&lang=js&"
export * from "./PR1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports